import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { UserProfilePage } from './user-profile';
import { SharedModule } from '../../../shared';
import { TranslateModule } from '@ngx-translate/core';
import { translateConfig } from '../../config/translate.config';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    UserProfilePage
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule.forChild([{ path: '', component: UserProfilePage }]),
    TranslateModule.forChild(translateConfig),
    SharedModule
  ]
})
export class UserProfileModule {}
